import { createEmptyClientVars } from '../../../core/factory/client-vars-factory';
import { ILocalEditContext } from '../core/interfaces/local-edit-context.interface';

export function createLocalEditClientVars(context: ILocalEditContext, text = '{}') {
    const clientVars = createEmptyClientVars();

    // 填充空值
    clientVars.collab_client_vars = clientVars.collab_client_vars ?? {};
    clientVars.collab_client_vars.client = clientVars.collab_client_vars.client ?? {};
    clientVars.collab_client_vars.initialAttributedText = clientVars.collab_client_vars.initialAttributedText ?? {};
    clientVars.privilegeAttribute = clientVars.privilegeAttribute ?? {};


    // 本地编辑初始化basicClientVars时确定登录状态
    // 未登录也无需修改文档 privilegeAttribute 确保未登录也可编辑文档
    if (!context.isLogin()) {
        clientVars.isLogin = false;
    }

    const userInfo = context.getUserInfo();
    if (userInfo) {
        clientVars.userInfo = userInfo;
        clientVars.userLoginCorpId = userInfo.corpId;
        clientVars.userLoginCorpName = userInfo.corpName;
    }

    clientVars.title = context.getTitle();
    clientVars.padTitle = context.getTitle();
    clientVars.globalPadId = context.getGlobalPadId();
    clientVars.localPadId = context.getGlobalPadId();
    clientVars.collab_client_vars.client.upid = context.getSecretId();
    clientVars.collab_client_vars.globalPadId = context.getGlobalPadId();
    clientVars.collab_client_vars.padId = context.getGlobalPadId();
    clientVars.collab_client_vars.initialAttributedText.text = text;
    clientVars.collab_client_vars.ver = Infinity;
    clientVars.collab_client_vars.dver = '3.0.0';
    clientVars.uin = context.getUserUin();
    clientVars.userId = context.getUserUid();
    clientVars.isOwner = true;

    window.clientVars = clientVars;
    dispatchEvent(new Event('clientVarsDataReady'));

    return clientVars;
}
